var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlack({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.636 14.896a2.308 2.308 0 01-2.31 2.31 2.308 2.308 0 01-2.31-2.31 2.308 2.308 0 012.31-2.31h2.31v2.31zm1.155 0a2.308 2.308 0 012.31-2.31 2.308 2.308 0 012.31 2.31v5.776a2.308 2.308 0 01-2.31 2.31 2.308 2.308 0 01-2.31-2.31v-5.776z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.103 5.62a2.308 2.308 0 01-2.31-2.31A2.308 2.308 0 019.103 1a2.308 2.308 0 012.31 2.31v2.31h-2.31zm0 1.173a2.308 2.308 0 012.31 2.31 2.308 2.308 0 01-2.31 2.31H3.31A2.308 2.308 0 011 9.104a2.308 2.308 0 012.31-2.31h5.793z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.362 9.103a2.308 2.308 0 012.31-2.31 2.308 2.308 0 012.31 2.31 2.308 2.308 0 01-2.31 2.31h-2.31v-2.31zm-1.156 0a2.308 2.308 0 01-2.31 2.31 2.308 2.308 0 01-2.31-2.31V3.31A2.308 2.308 0 0114.896 1a2.308 2.308 0 012.31 2.31v5.793z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.896 18.362a2.308 2.308 0 012.31 2.31 2.308 2.308 0 01-2.31 2.31 2.308 2.308 0 01-2.31-2.31v-2.31h2.31zm0-1.156a2.308 2.308 0 01-2.31-2.31 2.308 2.308 0 012.31-2.31h5.793a2.308 2.308 0 012.31 2.31 2.308 2.308 0 01-2.31 2.31h-5.793z",
    fill: "#ECB22E"
  })));
}

export default SvgSlack;